import { EdsLocaleItem } from '@eventim/eds2/user-menu';

export const DEFAULT_LOCALES: EdsLocaleItem[] = [
  {
    key: 'en-GB',
    label: 'English',
  },
  {
    key: 'de-DE',
    label: 'Deutsch',
  },
  {
    key: 'fr-FR',
    label: 'Français',
  },
];
